export default "__VITE_ASSET__DMJas2Rf__"